var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 19.375H1.875C1.54348 19.375 1.22554 19.2433 0.991117 19.0089C0.756696 18.7745 0.625 18.4565 0.625 18.125V1.25C0.625 1.08424 0.690848 0.925268 0.808058 0.808058C0.925268 0.690848 1.08424 0.625 1.25 0.625C1.41576 0.625 1.57473 0.690848 1.69194 0.808058C1.80915 0.925268 1.875 1.08424 1.875 1.25V18.125H18.75C18.9158 18.125 19.0747 18.1908 19.1919 18.3081C19.3092 18.4253 19.375 18.5842 19.375 18.75C19.375 18.9158 19.3092 19.0747 19.1919 19.1919C19.0747 19.3092 18.9158 19.375 18.75 19.375Z",
    fill: "#00858A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 16.875H4.53125C4.15829 16.875 3.8006 16.7268 3.53688 16.4631C3.27316 16.1994 3.125 15.8417 3.125 15.4688V9.53125C3.125 9.15829 3.27316 8.8006 3.53688 8.53688C3.8006 8.27316 4.15829 8.125 4.53125 8.125H6.09375C6.46671 8.125 6.8244 8.27316 7.08812 8.53688C7.35184 8.8006 7.5 9.15829 7.5 9.53125V15.4688C7.5 15.8417 7.35184 16.1994 7.08812 16.4631C6.8244 16.7268 6.46671 16.875 6.09375 16.875Z",
    fill: "#00858A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 16.875H10.1562C9.78329 16.875 9.4256 16.7268 9.16188 16.4631C8.89816 16.1994 8.75 15.8417 8.75 15.4688V7.65625C8.75 7.28329 8.89816 6.9256 9.16188 6.66188C9.4256 6.39816 9.78329 6.25 10.1562 6.25H11.7188C12.0917 6.25 12.4494 6.39816 12.7131 6.66188C12.9768 6.9256 13.125 7.28329 13.125 7.65625V15.4688C13.125 15.8417 12.9768 16.1994 12.7131 16.4631C12.4494 16.7268 12.0917 16.875 11.7188 16.875Z",
    fill: "#00858A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3296 16.875H15.7671C15.3941 16.875 15.0364 16.7268 14.7727 16.4631C14.509 16.1994 14.3608 15.8417 14.3608 15.4688V5.15625C14.3608 4.78329 14.509 4.4256 14.7727 4.16188C15.0364 3.89816 15.3941 3.75 15.7671 3.75H17.3296C17.7026 3.75 18.0602 3.89816 18.324 4.16188C18.5877 4.4256 18.7358 4.78329 18.7358 5.15625V15.4688C18.7358 15.8417 18.5877 16.1994 18.324 16.4631C18.0602 16.7268 17.7026 16.875 17.3296 16.875Z",
    fill: "#00858A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.88c260f09b6f73e0e0ba6f629d44775c.svg";
export { ForwardRef as ReactComponent };